import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import validator from "validator";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { ADMIN_LOCAL_STORE, CURRENT_YEAR, SALT } from "../../configs/AppConfig";
import { adminPost2FAVerifyQrCode, login } from "../../services/AdminService";
import { encryptData } from "../../utils/crypto";
import Logo from '../../assets/Images/Docusafe_logo.webp';

function AdminPortalLogin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [isVerify, setIsVerify] = useState(false);
    const [userData, setUserData] = useState({});
    const [code, setCode] = useState('');

    let errorsObj = { email: '', password: '', code: '' };
    const [errors, setErrors] = useState(errorsObj);

    function onLogin(e) {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };
        if (email === '') {
            errorObj.email = 'Email is required';
            error = true;
        } else if (!validator.isEmail(email)) {
            errorObj.email = 'Please enter a valid email address';
            error = true;
        }
        if (password === '') {
            errorObj.password = 'Password is required';
            error = true;
        }

        setErrors(errorObj);

        if (error) return;

        setLoading(true);
        let obj = {
            email: email,
            password: password
        };
        login(obj)
            .then(response => {
                if (response.data.data.qr_code) {
                    setIsVerify(true);
                    setLoading(false);
                    setUserData(response.data.data);
                } else {
                    let encryptedData = encryptData(response.data.data, SALT);
                    localStorage.setItem(ADMIN_LOCAL_STORE, encryptedData);
                    navigate('/back-admin');
                    setLoading(false);
                }
            })
            .catch(err => {
                toast.error(Utils.getErrorMessage(err));
                setLoading(false);
            });
    }

    const onVerify = (e) => {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };

        if (!code) {
            errorObj.code = 'Code is required';
            error = true;
        }

        setErrors(errorObj);

        if (error) return;

        setLoading(true);
        let data = { ...userData };

        let obj = {
            id: data.id,
            code: code
        };

        adminPost2FAVerifyQrCode(obj)
            .then(response => {
                let encryptedData = encryptData(userData, SALT);
                localStorage.setItem(ADMIN_LOCAL_STORE, encryptedData);
                setLoading(false);
                navigate('/back-admin');
            })
            .catch(err => {
                toast.error(Utils.getErrorMessage(err));
                setLoading(false);
            });
    };

    return (
        <div className="admin-login-page">
            <div className="admin-login-mesh"></div>
            {loading && (
                <div className="page-loading">
                    <img src="/images/loader.gif" alt="loader" className="page-loader" />
                </div>
            )}

            <div className="admin-login-container">
                <div className="admin-login-box">
                    <div className="text-center">
                        <img src={Logo} alt="DocuSafe.ai Logo" className="admin-login-docusafe-logo" />
                    </div>
                    <h2 className="admin-login-title">{isVerify ? 'Two Factor Authentication Code' : 'Login'}</h2>
                    {isVerify ? (
                        <form onSubmit={onVerify}>
                            <div className="form-group admin-login-section">
                                <label className="admin-login-form-label">Google Authenticator App Code</label>
                                <input
                                    type="number"
                                    className="admin-login-input"
                                    value={code}
                                    onChange={(e) => setCode(e.target.value)}
                                    placeholder="Enter 6-digit code found in your App"
                                />
                                {errors.code && <div className="text-danger">{errors.code}</div>}
                            </div>
                            <button type="submit" className="admin-login-submit-btn">Verify</button>
                        </form>
                    ) : (
                        <form onSubmit={onLogin}>
                            <div className="form-group admin-login-section">
                                <label className="admin-login-form-label">Email</label>
                                <input
                                    type="text"
                                    className="admin-login-input"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="user@example.com"
                                />
                                {errors.email && <div className="text-danger">{errors.email}</div>}
                            </div>
                            <div className="form-group admin-login-password-group admin-login-section">
                                <label className="admin-login-form-label">Password</label>
                                <input
                                    type="password"
                                    className="admin-login-input"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <NavLink to="/back-admin/forget-password" title="Forget password" className="admin-login-forget-password">
                                    Forget Password?
                                </NavLink>
                            </div>
                            <button type="submit" className="admin-login-submit-btn">Submit</button>
                        </form>
                    )}
                </div>
            </div>

            <div className="chat-icon">
                <div className="chat-circle"></div>
            </div>
        </div>
    );
}

export default AdminPortalLogin;